export class TokenRefreshError extends Error {
    constructor() {
        super('Access token could not be refreshed.');
        this.name = TokenRefreshError.name;
    }
}
